(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .constant('MODAL_CONTENT_TYPES', {
            FILTERS: 'filters',
            NEGOTIATION_FILTERS: 'negotiation_filters',
            NEGOTIATION: 'negotiation',
            CAMPAIGN: 'campaign',
            CAMPAIGN_SETTINGS: 'campaign_settings',
            CUSTOMER: 'customer',
            SALES_POINT: 'sales_point'
        });

})();
